import React, {useState, useRef, useEffect, FC, ReactElement, EffectCallback} from 'react';
import './content-panel-container.scss';

interface Props {
    children: ReactElement | ReactElement[];
}

export const ContentPanelContainer: FC<Props> = ({children}) => {
    const containerRef = useRef<HTMLDivElement>(null)
    useEffect( () => {
        if(!containerRef || !containerRef.current){

            return;
        }

        const windowHeight: number = window.innerHeight;
        const childContainers = 
        containerRef.current!.querySelectorAll('.content');

        containerRef.current.addEventListener('scroll', onWindowScroll);
        let x: number = 0;

        oneAtATime();
        
        function oneAtATime(){
            const position = childContainers[x].getBoundingClientRect()
            if (position.y <= windowHeight - 80) {
                childContainers[x].classList.add('visible');
            }
            x++;

            window.setTimeout(() => {
                if(x < childContainers.length){
                    oneAtATime();
                }
            }, 200);
        }
        

        function onWindowScroll(e: Event):void {
            cycleThroughContainers()
        }

        function cycleThroughContainers(){

            childContainers.forEach((item, index) => {
                const position = item.getBoundingClientRect()
                if(position.y <= windowHeight - 80){
                    item.classList.add('visible');
                }
            })
        }

        return () => {
            if(containerRef.current){
                containerRef.current!.removeEventListener('scroll', onWindowScroll);
            }
            
        }
    }, []);

    return (
        <div ref={containerRef}
            className='content-panel-container'
        >
            {children}
        </div>
    )
}